import * as React from 'react';

import {Button} from 'shells/button/button';
import {Dialog} from 'shells/dialog/dialog';

type Props = {
    companyName: string;
    onHideFutureRecommendations: () => void;
};

export function HideRecommendationsButton(props: Props) {
    const [isConfirming, setIsConfirming] = React.useState<boolean>(false);
    const buttonRef = React.useRef(null);

    return (
        <>
            <Button
                getButtonRef={buttonRef}
                onClick={() => setIsConfirming(true)}
                isFullWidth={true}
            >
                Hide recommendations for {props.companyName}
            </Button>
            {isConfirming && (
                <Dialog
                    anchor={buttonRef.current}
                    isWarning={true}
                    question={`Are you sure you want to hide recommendations for ${props.companyName}?`}
                    onPrimary={props.onHideFutureRecommendations}
                    onSecondary={() => {
                        setIsConfirming(false);
                    }}
                    primaryText='Yes, hide'
                    secondaryText='No, don’t hide'
                    location='top'
                />
            )}
        </>
    );
}
